import Head from 'next/head'
import { ApolloProvider } from '@apollo/client'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { gsap } from 'gsap/dist/gsap';
//import Cookies from 'universal-cookie'
import client from '../src/apollo/client'
import Loader from '../src/components/loader'
//import LoginPage from '../src/components/login'
import '../src/styles/index.scss';
// Page Music
import musicLink from "../public/sounds/AmbMusic.mp3";
import musicLink2 from "../public/sounds/AmbMusicDrama.mp3";
import loaderSound from "../public/sounds/LoadingLogoFlame.mp3"

// Page Image
import pageImage from './../public/images/fb-image.jpg';

const MyApp = ({ Component, pageProps }) => {
  // use router
  const router = useRouter();

  // ReSet page Data
  useEffect(() => {
    // On Mobile 
    const screenWidth = window.innerWidth;
    //console.log(screenWidth);
    if(screenWidth < 767) {
      if(router.asPath !== '/'){
        window.location.replace('/');
      };
    }

    // Add Default Data
    const today = new Date();
    const currentDate = today.getTime();
    const ClearDate = new Date(localStorage.getItem('ClearDate'));
    const nextClearDate = ClearDate.getTime() + (7 * 24 * 60 * 60 * 1000);
    if(nextClearDate < currentDate) {
      localStorage.setItem('ClearDate', today)
      // Set Room 1 Data
      const room1 = {
        marker1: {
          type: '',
          value: 0
        },
        marker2: {
          type: '',
          value: 0
        },
        marker3: {
          type: '',
          value: 0
        },
        marker4: {
          type: '',
          value: 0
        },
        marker5: {
          type: '',
          value: 0
        },
        marker6: {
          type: '',
          value: 0
        },
        marker7: {
          type: '',
          value: 0
        },
        marker8: {
          type: '',
          value: 0
        },
        marker9: {
          type: '',
          value: 0
        },
        marker10: {
          type: '',
          value: 0
        },
      }
      localStorage.setItem('room1', JSON.stringify(room1));
      // Set Room 2 Data
      const room2 = {
        marker1: {
          type: '',
          value: 0
        },
        marker2: {
          type: '',
          value: 0
        },
        marker3: {
          type: '',
          value: 0
        },
        marker4: {
          type: '',
          value: 0
        },
        marker5: {
          type: '',
          value: 0
        },
        marker6: {
          type: '',
          value: 0
        },
        marker7: {
          type: '',
          value: 0
        },
        marker8: {
          type: '',
          value: 0
        },
        marker9: {
          type: '',
          value: 0
        },
        marker10: {
          type: '',
          value: 0
        },
        marker11: {
          type: '',
          value: 0
        },
        marker12: {
          type: '',
          value: 0
        },
        marker13: {
          type: '',
          value: 0
        },
        marker14: {
          type: '',
          value: 0
        },
        marker15: {
          type: '',
          value: 0
        },
        marker16: {
          type: '',
          value: 0
        },
        marker17: {
          type: '',
          value: 0
        },
        marker18: {
          type: '',
          value: 0
        },
        marker19: {
          type: '',
          value: 0
        },
        marker20: {
          type: '',
          value: 0
        },
        marker21: {
          type: '',
          value: 0
        },
        marker22: {
          type: '',
          value: 0
        },
        marker23: {
          type: '',
          value: 0
        },
        marker24: {
          type: '',
          value: 0
        }
      }
      localStorage.setItem('room2', JSON.stringify(room2));
      // Set Room 3 Data
      const room3 = {
        marker1: {
          type: '',
          value: 0
        },
        marker2: {
          type: '',
          value: 0
        },
        marker3: {
          type: '',
          value: 0
        },
        marker4: {
          type: '',
          value: 0
        },
        marker5: {
          type: '',
          value: 0
        },
        marker6: {
          type: '',
          value: 0
        },
        marker7: {
          type: '',
          value: 0
        },
        marker8: {
          type: '',
          value: 0
        }
      }
      localStorage.setItem('room3', JSON.stringify(room3));
      // Set Room 4 Data
      const room4 = {
        marker1: {
          type: '',
          value: 0
        },
        marker2: {
          type: '',
          value: 0
        },
        marker3: {
          type: '',
          value: 0
        },
        marker4: {
          type: '',
          value: 0
        },
        marker5: {
          type: '',
          value: 0
        },
        marker6: {
          type: '',
          value: 0
        },
        marker7: {
          type: '',
          value: 0
        },
        marker8: {
          type: '',
          value: 0
        },
        marker9: {
          type: '',
          value: 0
        },
        marker10: {
          type: '',
          value: 0
        },
        marker11: {
          type: '',
          value: 0
        },
        marker12: {
          type: '',
          value: 0
        }
      }
      localStorage.setItem('room4', JSON.stringify(room4));
    }
  }, []);

  const [loading, setLoading] = useState(true);
  const [hideLoader, setHideLoader] = useState(false);
  setTimeout(() => setLoading(false), 1000)

  useEffect(() => {
    // Loading Page 
    router.events.on('routeChangeStart', () => setLoading(true));
    router.events.on('routeChangeComplete', () => setTimeout(() => setLoading(false), 1000) );
    router.events.on('routeChangeError', () => setTimeout(() => setLoading(false), 1000) );
    return () => {
      router.events.off('routeChangeStart', () => setLoading(true));
      router.events.off('routeChangeComplete', () => setTimeout(() => setLoading(false), 1000) );
      router.events.off('routeChangeError', () => setTimeout(() => setLoading(false), 1000) );
    };
    // Play Background Music
    //backgroundMusic();
  }, [router.events]);

  const [audio, setAudio] = useState(null);
  const [audio2, setAudio2] = useState(null);
  const [loaderAudio, setLoaderAudio] = useState(null);
  function isPlaying(audelem) { return !audelem?.paused; }
  // Get Page name
  var locs = router.asPath.replace(/\.\w+$/, '').split('/');

  // Loader Audio
  useEffect(() => {
    if(!loaderAudio) {
      setLoaderAudio(new Audio(loaderSound));
    }
    // On End audio
    if(loaderAudio) {
      loaderAudio.addEventListener("ended", () => {
        loaderAudio.currentTime = 0;
        loaderAudio.play();
      }, false);
    }
  }, [loaderAudio])

  // Use Effect
  useEffect(() => {
    if(!audio) {
      setAudio(new Audio(musicLink));
    }
    //console.log(audio);
    const backAudio = localStorage.getItem("backgroundMusic");
    //console.log(backAudio);
    //console.log(router.asPath);
    if(!isPlaying(audio) && backAudio === null) {
      localStorage.setItem("backgroundMusic", "playing");
      if(locs[locs.length - 2] !== 'room2' && locs[locs.length - 2] !== 'room3' && locs[locs.length - 2] !== 'hidden-secret' && locs[locs.length - 2] !== 'monastery' && locs[locs.length - 2] !== 'fake-identity' && locs[locs.length - 2] !== 'children' && router.asPath !== '/story/room2/result/' && router.asPath !== '/story/room3/result/') {
        audio.play();
        audio.loop = true;
        audio2.pause();
      } else {
        audio2.muted = true;
        audio2.play();
        // Toggle volume
        gsap.to(audio2, {volume: 1, duration: 2});
        audio2.loop = true;
        audio.pause();
      }
    }
    // On End audio
    if(audio) {
      audio.addEventListener("ended", () => {
        audio.currentTime = 0;
        audio.play();
      }, false);
    }
  }, [audio, audio2, locs, router.asPath]);

  // Second Music
  useEffect(() => {
    if(!audio2) {
      setAudio2(new Audio(musicLink2));
    }
    //console.log(audio2);
    
    // On End audio
    if(audio2) {
      audio2.addEventListener("ended", () => {
        audio2.currentTime = 0;
        audio2.play();
      }, false);
    }
  }, [audio2]);

  // If not Loaded
  if (loading) {
    setTimeout(() => {
      setHideLoader(true);
    }, 0);
    return '';
  }
  //console.log(loaderAudio);
  // Head Data
  const headData = {
    title: `'במסתרים׳ ילדי מסתור בתקופת השואה. תערוכה וירטואלית.`,
    description: "גנזך קידוש השם מציגים: חוויה אינטראקטיבית על ילדי מסתור בתקופת השואה. למדו על פרידתם מההורים, המסתור, ההצלה והשיקום לאחר המלחמה. מותאם לבני נוער. התחילו בסיור.",
    url: "https://ganzach.org.il/",
    image: pageImage.src,
  }
  return(
    <>
      <ApolloProvider client={client}>
      <Head>
            <meta property="og:title" content={headData.title} key="og-title" />
            <meta property="og:description" content={headData.description} key="og-desc" />
            <meta property="og:url" content={headData.url} key="og-url" />
            <meta property="og:image" content={headData.image} key="og-image" />
            <meta property="og:site_name" content="Bamistarim Ganzach" key="og-site" />
            <meta name="twitter:title" content={headData.title} key="tw-title" />
            <meta name="twitter:description" content={headData.description} key="tw-desc" />
            <meta name="twitter:image" content={headData.image} key="tw-image" />
            <meta name="twitter:card" content="summary_large_image" key="tw-card" />
        </Head>
        <Loader loaded={hideLoader} audio={loaderAudio} dataAudio={audio} dataAudio2={audio2} />
        <Component {...pageProps} dataAudio={audio} dataAudio2={audio2} />
      </ApolloProvider>
    </>
  )
}

export default MyApp;